
function Preview() {
return (
    <div className="preview">
        <p className="preview__title">О серии</p>
        <div className="preview__text">
        Седьмое поколение самой популярной линейки компании Monitor Audio – Silver – воплощает богатый опыт британских инженеров, насчитывающий несколько десятилетий. Благодаря использованию натурального шпона в отделке корпусов, колонки имеют изысканный 
и элегантный вид. Мощное насыщенное звучание обеспечивается новейшими фирменными технологиями.
        </div>  
    </div>
)}
export default Preview;